<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.29757 17.592C4.50747 18.3078 4.19492 19.2143 4.19492 20.0086C4.19492 20.5609 3.7472 21.0086 3.19492 21.0086C2.64263 21.0086 2.19492 20.5609 2.19492 20.0086C2.19492 18.6943 2.71419 17.2338 3.95469 16.1099C5.19767 14.9836 7.07409 14.2746 9.6537 14.2746C12.231 14.2746 14.1067 14.9778 15.35 16.0988C16.5917 17.2183 17.1115 18.6751 17.1115 19.9905C17.1115 20.5428 16.6638 20.9905 16.1115 20.9905C15.5592 20.9905 15.1115 20.5428 15.1115 19.9905C15.1115 19.1964 14.7995 18.2952 14.0108 17.5842C13.2238 16.8746 11.8706 16.2746 9.6537 16.2746C7.43817 16.2746 6.0852 16.8783 5.29757 17.592Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.65362 5.00903C7.92833 5.00903 6.5289 6.40817 6.5289 8.1347C6.5289 9.86119 7.92832 11.2603 9.65362 11.2603C11.38 11.2603 12.7793 9.86104 12.7793 8.1347C12.7793 6.40832 11.38 5.00903 9.65362 5.00903ZM4.5289 8.1347C4.5289 5.3039 6.82346 3.00903 9.65362 3.00903C12.4846 3.00903 14.7793 5.30375 14.7793 8.1347C14.7793 10.9656 12.4846 13.2603 9.65362 13.2603C6.82347 13.2603 4.5289 10.9655 4.5289 8.1347Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.3501 14.7532C16.4612 14.2122 16.9898 13.8637 17.5308 13.9748C19.1076 14.2985 20.2161 15.0543 20.9198 16.0194C21.6107 16.967 21.8632 18.0493 21.8632 18.974C21.8632 19.5263 21.4155 19.974 20.8632 19.974C20.3109 19.974 19.8632 19.5263 19.8632 18.974C19.8632 18.3946 19.7027 17.7449 19.3037 17.1977C18.9175 16.6679 18.2592 16.166 17.1286 15.9339C16.5876 15.8228 16.2391 15.2942 16.3501 14.7532Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4348 5.46897C15.5475 4.92832 16.0772 4.58142 16.6178 4.69415C18.4659 5.0795 19.8504 6.71837 19.8442 8.6798C19.8378 10.416 18.7427 11.8933 17.2078 12.467C16.6905 12.6603 16.1143 12.3977 15.921 11.8803C15.7276 11.363 15.9903 10.7869 16.5076 10.5935C17.2876 10.302 17.8408 9.55186 17.8442 8.67344M15.4348 5.46897C15.322 6.00963 15.6689 6.53931 16.2096 6.65204L15.4348 5.46897ZM16.2096 6.65204C17.1462 6.84734 17.8473 7.6801 17.8442 8.67344L16.2096 6.65204Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
